import { FlaskConical } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

import { useAuth } from '@/features/auth';
import { ROUTES } from '@/shared/constants/routes';

import { demoSession } from '../lib/demo-session';

/**
 * Persistent "you are in the demo" marker and a way back to the walkthrough.
 *
 * Deliberately a small floating pill rather than a top banner: a full-width bar
 * would sit under every screen's sticky header and shift the layout the
 * reviewer is meant to be evaluating. It clears the bottom navigation so it
 * never covers a tab.
 */
export function DemoBadge() {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  // Gated on the session rather than only on the marker: after logout the
  // marker may linger in the tab, and a badge linking into a guarded route
  // would just bounce the user to the login screen.
  if (!isAuthenticated) return null;

  // Reading on every render is intentional — sessionStorage is synchronous and
  // this must react to a demo session starting mid-visit.
  if (!demoSession.isActive()) return null;
  if (location.pathname === ROUTES.demo) return null;

  return (
    // Positioned inside the app column, not the viewport: on desktop a plain
    // `fixed … start-4` would strand the pill against the far screen edge,
    // detached from the app it belongs to.
    <div className="pointer-events-none fixed inset-x-0 bottom-[calc(4.25rem+env(safe-area-inset-bottom,0px))] z-50">
      <div className="app-shell relative px-4">
        <Link
          to={ROUTES.demo}
          className="bg-foreground/90 text-background shadow-overlay pointer-events-auto inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-[11px] font-medium backdrop-blur-sm"
        >
          <FlaskConical className="size-3.5" aria-hidden />
          حالت نمایشی
        </Link>
      </div>
    </div>
  );
}
